export default {
  updated() {
    if (this.el.dataset.content) {
      this.pushEvent("clear_flash", { type: this.el.id });
    }
  }
}
